

export default {
  clubInfo: JSON.parse(localStorage.getItem('clubInfo')) || {}
}
